


















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import vueformmodel from '../../../lib/vueformmodel';
import { FormItem } from 'view-design';
@Component
export default class storagequeryproductchanneledit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;
    model: proxy.StorageQueryProductChannelDto = new proxy.StorageQueryProductChannelDto();
    ctypes: any[] = [];
    tabValue="detail";
    b_disabled = false;
    selectchannels:any[]=[];
    allchannels: any[] = [];
    get prox() {
        return new proxy.StorageQueryProductChannelServiceProxy();
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.tabValue = "detail"
            this.$emit('input', value);
        }else{
            this.b_disabled = true;
            let req2 = new proxy.ChannelTypePageInputDto();
            req2.maxResultCount = 500;
            req2.sorting = 'code asc, id desc';
            new proxy.ChannelTypeServiceProxy().queryModelList(req2).then(x => {
                this.ctypes = x.items;
                this.ctypes.map(x => {
                    x.check = false;
                })
                let req3 = new proxy.ChannelSimpleInputDto();
                this.selectchannels = []
                this.prox.queryModel(this.id).then(x => {
                    this.model = x;
                    console.log(this.model);
                    if (this.model.storageProductChannels && this.model.storageProductChannels.length) {
                        this.ctypes.map(c => {
                            let i = this.model.storageProducts.findIndex(p => p.channelTypeId == c.id);
                            if (i != -1) {
                                c.check = true;
                                c.rate = this.model.storageProducts[i].rate || 0;
                            }
                        })
                    }
                    new proxy.ChannelServiceProxy().queryAllList(req3).then(x => {
                        this.allchannels = x.sort((a, b) => a.rate - b.rate);

                        this.checkchange();
                        this.b_disabled = false;
                    });
                });
            });
        }
    }
//     save() {

// this.model.storageProductChannels = this.selectchannels.filter(x => x._checked);

// let arr = this.ctypes.filter(x => x.check).map(x => {
//     let m = new proxy.StorageProductDto();
//     m.channelTypeId = x.id;
//     m.rate = x.rate;
//     return m;
// })

// this.model.storageProducts = arr;

// this.model = proxy.StorageQueryProductChannelDto.fromJS(this.model);
// (this.$refs.roleForm as any).validate(async (valid: boolean) => {
//     if (valid) {
//         this.prox.createOrUpdate(this.model).then(() => {
//             (this.$refs.roleForm as any).resetFields();
//             this.$Notice.success({ title: '保存成功' });
//             this.$emit('save-success');
//             this.$emit('input', false);
//         });
//     }
// });
// }
cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.tabValue = "detail";
        this.$emit('input', false);
    }
    checkchange(){
        let arr2: any[] = []
        this.ctypes.map(x => {
            if (x.check) {
                let arr3 = [];
                x.channelTypeChannels.map(cn=>{
                    if (arr3.findIndex(p => p.channelId == cn.channelId && p.channelTypeId == x.id) == -1) 
                    {
                        let c = this.allchannels.find(p => p.id == cn.channelId);
                        if(c){
                            let m = {
                                channelId: c.id,
                                id: 0,
                                _disabled: false,
                                _checked: false,
                                weight: 1,
                                name: c.name,
                                status: c.status,
                                typename: x.name,
                                typecode: x.code,
                                channelTypeId: x.id,
                                crate: c.rate
                            }
                            let sc = this.selectchannels.find(x => x.channelId == m.channelId && x.channelTypeId == m.channelTypeId);
                            if (sc) {
                                m._checked = sc._checked;
                            }
                            if (this.model.storageProductChannels && this.model.storageProductChannels.length) {
                                let index = this.model.storageProductChannels.findIndex(p => p.channelId == c.id && p.channelTypeId == x.id);
                                if (index != -1) {
                                    m._checked = true;
                                    if (this.model.storageProductChannels[index].weight > 0) {
                                        m.weight = this.model.storageProductChannels[index].weight;
                                    }

                                }
                            }
                            arr3.push(m);
                        }
                    }
                })
                arr3 = arr3.sort((a, b) => a.crate - b.crate);
                arr2.push(...arr3);
            }
        });
        this.selectchannels = arr2;
    }
    roleRule = {

};
}
